<div class="d-flex w-100 pulse-animation" [ngStyle]="{'width': width ? width + 'px' : '100%'}" [style.height]="height + 'px'" >
  <div class="img-placeholder"></div>
</div>